// noinspection SpellCheckingInspection

import React, { useEffect, useState } from 'react';
import './styles';
import * as PackageType from '../../../../utils/Helpers/PackageType/PackageType';
import PLMap from '../../../../components/PL/PLMap';
import UIOptionGroup from '../../../../components/UI/UIOptionGroup';
import UILoadingPage from '../../../../components/UI/UILoadingPage/UILoadingPage';
import UIController from '../../../../components/UI/UIController';
import Helmet from 'react-helmet';
import UIDropdownSelect from '../../../../components/UI/UIDropdownSelect';
import { setUpBookableOptions } from '../EditOptions/config';
import { useRouteMatch } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_INDIVIDUAL_REGIONS_QUERY } from './queries';
import { SOURCES } from '../../../../components/PL/PLMap/config';

let ReactMapboxGl, Layer, Feature, Popup, Source;
if (process.env.BUILD_TARGET === 'client') {
	ReactMapboxGl = require('react-mapbox-gl');
	Layer = ReactMapboxGl.Layer;
	Feature = ReactMapboxGl.Feature;
	Popup = ReactMapboxGl.Popup;
	Source = ReactMapboxGl.Source;
}

export default function IndividualRegion({}: IndividualRegionProps) {
	const TABS = {
		PRICING: { value: 'regionPricing', text: 'Region pricing' },
		MAP: { value: 'regionMap', text: 'Service area' }
	};

	const [selectedTab, setSelectedTab] = useState<PLTab>(TABS.PRICING);
	const [selectedRegion, setSelectedRegion] = useState<RegionType>();

	const match = useRouteMatch();

	const [getRegion, { data: regionData }] = useLazyQuery(GET_INDIVIDUAL_REGIONS_QUERY, {
		variables: { q: { infoPath: { op_eq: match.params['infoPath'] } } }
	});

	useEffect(() => {
		(async () => {
			await getRegion();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (regionData) {
				const fetchedRegions: RegionType[] = regionData['regions'];
				setSelectedRegion(fetchedRegions[0]);
			}
		})();
	}, [regionData]);

	if (!selectedRegion) {
		return <UILoadingPage />;
	}

	const renderTabComponent = () => {
		return <UIDropdownSelect containerClassName='regionsTabBar' selectedTab={selectedTab} tabs={[TABS.PRICING, TABS.MAP]} updateSelected={setSelectedTab} />;
	};

	const getPageComponent = () => {
		let regionZipsArray = ['in', 'GEOID10'];
		regionZipsArray.push.apply(regionZipsArray, selectedRegion.zipCodes);
		switch (selectedTab.value) {
			case TABS.MAP.value:
				return (
					<div className='individualRegion__content'>
						<PLMap
							style={'mapbox://styles/carsonaberle/ckcky7wct04xu1io7x1q9ykl5'}
							center={[selectedRegion.longitude, selectedRegion.latitude]}
							zoom={[7]}
							noLocation
							containerStyle={{
								height: '100%',
								width: '100%',
								borderRadius: 16,
								overflow: 'hidden',
								marginLeft: 4
							}}>
							<Source id='zipSource' tileJsonSource={SOURCES.US_ZIP_CODES} />
							<Layer
								type='fill'
								id='layer_id'
								filter={regionZipsArray}
								paint={{
									'fill-color': '#89C1B5',
									'fill-opacity': 0.25
								}}
								before={'road-label'}
								sourceId={'zipSource'}
								sourceLayer='zcta5-8785yf'
							/>
							<Layer
								type='line'
								id='outlineLayerId'
								paint={{
									'line-color': '#CCCCCC',
									'line-opacity': 0.25,
									'line-width': 2
								}}
								filter={regionZipsArray}
								minZoom={7}
								before={'layer_id'}
								sourceId={'zipSource'}
								sourceLayer='zcta5-8785yf'
							/>
							<Layer
								type='fill'
								id='unselectedLayerId'
								paint={{
									'fill-color': '#FFFFFF',
									'fill-opacity': 0.1
								}}
								minZoom={8}
								before={'layer_id'}
								sourceId={'zipSource'}
								sourceLayer='zcta5-8785yf'
							/>
						</PLMap>
					</div>
				);
			case TABS.PRICING.value:
				return (
					<div className='individualRegion__content'>
						<UIOptionGroup
							selectedOptions={[]}
							updateSelectedOptions={() => {}}
							optionGroups={[
								PackageType.PHOTO_TYPE,
								PackageType.DRONE_TYPE,
								PackageType.VIDEO_TYPE,
								PackageType.FLOOR_PLAN_TYPE,
								PackageType.MATTERPORT_TYPE
							]}
							bookableOptions={setUpBookableOptions(selectedRegion.options, [])}
						/>
					</div>
				);

			default:
				return undefined;
		}
	};

	return (
		<UIController bodyClassName='individualRegion'>
			<Helmet>
				<title>{selectedRegion.name} | Pineapple Labs</title>
				<meta property='og:title' content={`${selectedRegion.name} | Pineapple Labs`} />
			</Helmet>
			<h1 className='individualRegion--heading'>{selectedRegion.name} pricing and coverage</h1>
			{renderTabComponent()}
			{getPageComponent()}
		</UIController>
	);
}
